import type { DiscountType, DiscountFormState } from "@lemmonhq/types";

export const formatDiscountValue = (
  type: "fixed-amount" | "percentage",
  value: number,
  currencyLabel: string,
): string => {
  return type === "percentage"
    ? `${value}%`
    : `${value.toFixed(2)} ${currencyLabel}`;
};

export const discountToFormState = (
  discount: DiscountType,
): DiscountFormState => ({
  title: discount.name,
  type: discount.default.type,
  value: discount.default.value.toString(),
  allow_changes: discount.allow_changes,
});

export const validateDiscountForm = (
  form: DiscountFormState,
  t: (key: string) => string,
): string | null => {
  const rawValue = form.value.trim();
  const value = Number(rawValue);

  if (!form.title.trim()) {
    return t("settings.discount_types_page.validation_enter_name");
  }

  if (!rawValue || !Number.isFinite(value)) {
    return t("settings.discount_types_page.validation_enter_value");
  }

  if (form.type === "percentage" && (value < 0 || value > 100)) {
    return t("settings.discount_types_page.validation_percentage_range");
  }

  if (form.type === "fixed-amount" && value < 0) {
    return t("settings.discount_types_page.validation_positive_amount");
  }

  return null;
};
